<template>
  <div class="component-content sub-content">
    <div class="list-title no-bottom-border">
      <div class="r">
        <router-link to="/Personnel/Vacation/Apply">
          <el-button type="primary" size="mini">请假/休假申请</el-button>
        </router-link>
      </div>

      <el-row class="item-select">
        <el-col :span="8">
          <label>所属公司：</label>
          <el-select size="mini" :disabled="noSelectOrganization" class="organization-select" v-model="depId"
            placeholder="请选择所属公司">
            <el-option v-for="item in organizationListData" :key="item.id" :label="item.name" :value="item.id">
            </el-option>
          </el-select>
        </el-col>

        <!-- <el-col class="item-input" :span="8">
          <label>搜索：</label>
          <el-input v-model="filterKey" size="mini" placeholder="你可以搜索审批类型/标题/审批发起人"></el-input>
        </el-col> -->
      </el-row>
    </div>

    <div class="tab-radio-tool">
      <el-radio-group size="mini" v-model="listType">
        <el-radio-button label="0">进行中</el-radio-button>
        <el-radio-button label="1">已审批(已取消、已拒绝)</el-radio-button>
      </el-radio-group>
    </div>

    <div class="list-title" style="padding:5px 10px 8px;background:#f8f8f8;">
      <!-- 条件搜索 -->
      <!-- <h3 class="title" style="float:none;border-bottom:1px #ccc solid;margin-bottom:5px;">
        条件搜索
        <span class="tip" style="font-size:12px;">（搜索条件为选填, 然后点击搜索按钮进行搜索）</span>
      </h3> -->
      <section style="margin-top:5px;">
        <label class="label-name">请假类别：</label>
        <el-select size="small" clearable v-model="filter.type" placeholder="请选择请假类别">
          <el-option v-for="item in typeArr" :key="item" :label="item" :value="item">
          </el-option>
        </el-select>
        <label class="label-name" style="margin-left:15px;">时间：</label>
        <el-date-picker v-model="filter.startTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          style="width:170px!important;" placeholder="选择时间"></el-date-picker>
        至
        <el-date-picker v-model="filter.endTime" size="small" value-format="yyyy-MM-dd HH:mm:ss" type="datetime"
          style="width:170px!important;" placeholder="选择时间"></el-date-picker>
        <!-- <el-button type="success" @click="getFilterData()" size="mini">搜索</el-button> -->
        <label class="label-name" style="margin-left:15px;">姓名：</label>
        <el-input v-model="filter.name" style="width:150px!important;" size="small"></el-input>
      </section>
    </div>

    <el-table :data="paginationData" border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>

      <el-table-column label="请假原因">
        <template slot-scope="scope">
          <span
            style="padding:1px 3px;background:#888;color:#fff;border-radius:3px;margin-right:5px;">{{ scope.row.type }}</span>{{ scope.row.content }}
        </template>
      </el-table-column>
      <el-table-column label="请假时间" width="230px">
        <template slot-scope="scope">
          {{ getSTime(scope.row.startTime) }} 至 {{ getSTime(scope.row.endTime) }}
        </template>
      </el-table-column>
      <el-table-column label="请假时长(天)" width="80px" align="center" prop="totalTime"></el-table-column>

      <el-table-column label="请假发起人" width="150px">
        <template slot-scope="scope">
          <user-info :userData='scope.row.flow.creator'></user-info>
        </template>
      </el-table-column>

      <el-table-column label="审批状态" width="100px" align="center">
        <template slot-scope="scope">
          <approval-status :flow="scope.row.flow" :approvals="scope.row.flow.approvals" :status="scope.row.flow.status"></approval-status>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="120px">
        <template slot-scope="scope">
          <el-button plain size="mini" @click="projectDetail(scope.row)">详情</el-button>

          <!-- 填表人修改权限 -->
          <span v-if="scope.row.flow.creator.id==userData.id">
            <span
              v-if="(scope.row.flow.status == '进行中'||scope.row.flow.status == '已拒绝'||scope.row.flow.status == '已取消')">
              <el-tooltip class="item" effect="dark" content="修改通用审批" placement="bottom">
                <i class="iconfont icon-xiugai meeting-btn-icon mbi-edit"
                  @click="getRouterLink(scope.row.flow.applyId, scope.row.projectId)"></i>
              </el-tooltip>
            </span>

            <!-- 个人取消审批 -->
            <!-- <cancel-flow :flow="scope.row.flow" @getLists='getLists'>
            </cancel-flow> -->
          </span>

          <!-- 管理员取消审批 -->
          <cancel-flow v-if="scope.row.flow.creator.id==userData.id || backRole('RS_7')" :flow="scope.row.flow"
            :successPlus="backRole('RS_7')" @getLists='getLists'>
          </cancel-flow>



        </template>
      </el-table-column>

    </el-table>
    <el-pagination v-if="filterData.length>pageSize" class="list-pagination" background :page-size="pageSize"
      :pager-count="9" :current-page="currentPage" layout="pager" :total="filterData.length"
      @current-change="handleCurrentChange">
    </el-pagination>

    <project-info></project-info>

  </div>
</template>

<script>
  import {
    mapState
  } from "vuex";

  import UserInfo from '@/components/UserInfo'
  import ApprovalStatus from '@/components/ApprovalStatus'
  import projectInfo from '@/page/user/projectInfo'
  import Role from '@/Mixins/role'
  import CancelFlow from '@/components/CancelFlow'
  export default {
    components: {
      UserInfo,
      projectInfo,
      ApprovalStatus,
      CancelFlow,
    },
    mixins: [Role],
    computed: {
      ...mapState({
        organization: state => state.main.organization,
        userData: state => state.main.userData,
      })
    },
    data() {
      return {
        organizationListData: [],
        noSelectOrganization: true,
        depId: '',

        // 列表
        loading: true,
        pageSize: 20,
        currentPage: 1,
        listData: [],
        filterData: [],
        paginationData: [],

        // 筛选搜索
        filterKey: "",

        listType: 0,

        // 取消审批相关
        cancleStatus: false,
        form: {
          flowId: '',
          remark: '',
        },
        typeArr: ['公出', '调休', '病假', '事假', '年休假', '其他', ],
        filter: {
          type: '',
          startTime: '',
          endTime: '',
          name: ''
        },

        // 总是可以取消
        // alwaysShow: false
      }
    },
    created() {

    },
    mounted() {
      // this.organizationListData.push({
      //   id: 0,
      //   name: "集团所有公司",
      //   depId: 0
      // })
      let _or = this.organization.length > 0 ? this.organization[0].childDepts : []
      this.organizationListData = this.organizationListData.concat(_or)

      this.depId = this.userData.secDepIds.split(",")[0] / 1

      if (this.backRole('SYSTEM_1')) {
        this.noSelectOrganization = false
        // this.depId = 0
      }

    },
    methods: {
      // 时间截取
      getSTime(time) {
        let _t = time.split(":")
        return _t[0] + ":" + _t[1]
      },
      // 编辑的链接生成
      getRouterLink(applyId, projectId) {
        this.$router.push({
          path: '/Personnel/Vacation/Apply/',
          query: {
            applyId: applyId,
          }
        })
      },

      // 显示审批详情
      projectDetail(row) {
        console.log(row)
        let _projectTable = {
          status: true,
          applyId: row.flow.applyId,
          tableType: row.flow.flowsource,
        }
        this.$store.commit('set_projectTable', _projectTable)
      },
      // 当前页
      handleCurrentChange(val) {
        this.currentPage = val
        this.getPaginationData()
      },
      // 搜索筛选数据
      getFilterData() {
        let _time
        if (this.filter.time) {
          _time = new Date(this.filter.time).getTime()
        }

        // 筛选出所有符合的数据
        this.filterData = []
        for (let i = 0; i < this.listData.length; i++) {
          let _item = this.listData[i]

          // 类型
          let _type = false
          if (!this.filter.type || _item.type == this.filter.type) {
            _type = true
          }

          // 时间
          let _t_time = false
          if (!this.filter.startTime) {
            if (!this.filter.endTime) {
              // 两个时间都没有
              _t_time = true
            } else {
              // 有结束时间
              if (_item.startTime < this.filter.endTime || _item.startTime == this.filter.endTime) {
                _t_time = true
              }
            }
          } else {
            // 判断符合开始时间的
            if (_item.startTime > this.filter.startTime || _item.startTime == this.filter.startTime) {
              // 没有结束时间
              if (!this.filter.endTime) {
                _t_time = true
              } else {
                // 有结束时间
                if (_item.startTime < this.filter.endTime || _item.startTime == this.filter.endTime) {
                  _t_time = true
                }
              }
            }
          }

          // 姓名
          let _name = false
          if (!this.filter.name) {
            _name = true
          } else {
            console.log(_item.creator.name.toLowerCase())
            if (_item.creator.name.toLowerCase().indexOf(this.filter.name) !=
              -1) {
              _name = true
            }
          }

          if (_type && _t_time && _name) {
            this.filterData.push(_item)
          }
        }

        this.currentPage = 1
        this.getPaginationData()
      },
      // 分页筛选数据
      getPaginationData() {
        if (!(this.pageSize * (this.currentPage - 1) < this.filterData.length)) {
          this.currentPage = Math.ceil(this.filterData.length / this.pageSize)
        }
        if (this.currentPage == 0) {
          this.currentPage = 1
        }
        // 分页筛选
        this.paginationData = this.filterData.slice(this.pageSize * (this.currentPage - 1), this.pageSize * this
          .currentPage)
      },
      // 是否是审批人
      isApprovalUser(approvalUserData) {
        let _r = false
        for (let i = 0; i < approvalUserData.length; i++) {
          if (approvalUserData[i].user && approvalUserData[i].user.id == this.userData.id) {
            _r = true
          }
        }
        // if (this.admin && this.admin.id == this.userData.id) {
        //   _r = true
        // }
        return _r
      },
      // 获取列表
      getLists() {
        this.loading = true
        ajax.get('/human/leave/apply/list', {
          'depId': this.depId == 0 ? "" : this.depId,
          'type': this.listType
        }, (res) => {
          this.loading = false

          // 请列表区分权限(只显示 有权限的人员(审批人+管理员)及当事人)
          let allList = res.vo.array
          let _list = []
          for (let i = 0; i < allList.length; i++) {
            let _item = allList[i]
            if (_item.creator.id === this.userData.id || this.isApprovalUser(_item.flow.approvals) || this
              .isSystemAdmin() || this.backRole('RS_6')) {
              _list.push(_item)
            }
          }

          this.filterData = this.listData = _list //res.vo.array
          this.getFilterData()
        })
      },
    },
    watch: {
      'depId'() {
        this.currentPage = 1
        this.getLists()
      },
      'filterKey'() {
        this.getFilterData()
      },

      listType() {
        this.currentPage = 1
        this.getLists()
      },

      'filter.type'() {
        this.getFilterData()
      },
      'filter.startTime'() {
        this.getFilterData()
      },
      'filter.endTime'() {
        this.getFilterData()
      },
      'filter.name'() {
        this.getFilterData()
      },
    }
  };
</script>


// WEBPACK FOOTER //
// src/page/personnel/vacationList.vue